// Máscaras de input — sem dependência, via delegação de eventos.
// Uso nas views:
//   data-mask="cep"    -> 00000-000
//   data-mask="phone"  -> (00) 0000-0000 ou (00) 00000-0000 (fixo/celular)
//   data-mask="document" -> CPF (000.000.000-00) até 11 dígitos, CNPJ depois
//   data-lowercase     -> email sempre minúsculo
//
// A formatação acontece ao digitar (preservando a posição do cursor) e também
// nos valores já preenchidos (edição), via formatPrefilled() no carregamento.

const onlyDigits = (s) => (s || "").replace(/\D/g, "")

function formatCEP(value) {
  const d = onlyDigits(value).slice(0, 8)
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d
}

function formatPhone(value) {
  const d = onlyDigits(value).slice(0, 11)
  const ddd = d.slice(0, 2)
  const rest = d.slice(2)
  if (d.length === 0) return ""
  if (d.length <= 2) return `(${ddd}`
  if (rest.length <= 4) return `(${ddd}) ${rest}`
  if (d.length <= 10) return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}` // fixo
  return `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}` // celular
}

function formatCNPJ(value) {
  const d = onlyDigits(value).slice(0, 14)
  let out = d.slice(0, 2)
  if (d.length > 2) out += `.${d.slice(2, 5)}`
  if (d.length > 5) out += `.${d.slice(5, 8)}`
  if (d.length > 8) out += `/${d.slice(8, 12)}`
  if (d.length > 12) out += `-${d.slice(12, 14)}`
  return out
}

function formatCPF(value) {
  const d = onlyDigits(value).slice(0, 11)
  let out = d.slice(0, 3)
  if (d.length > 3) out += `.${d.slice(3, 6)}`
  if (d.length > 6) out += `.${d.slice(6, 9)}`
  if (d.length > 9) out += `-${d.slice(9, 11)}`
  return out
}

// CPF ou CNPJ no mesmo campo: o 12º dígito vira a máscara para CNPJ.
const formatDocument = (value) =>
  onlyDigits(value).length > 11 ? formatCNPJ(value) : formatCPF(value)

const FORMATTERS = { cep: formatCEP, phone: formatPhone, cnpj: formatCNPJ, document: formatDocument }

// Reformata o campo mantendo o cursor após a mesma quantidade de dígitos.
function applyMask(el, formatter) {
  const caret = el.selectionStart ?? el.value.length
  const digitsBeforeCaret = onlyDigits(el.value.slice(0, caret)).length

  el.value = formatter(el.value)

  let pos = 0
  let seen = 0
  while (pos < el.value.length && seen < digitsBeforeCaret) {
    if (/\d/.test(el.value[pos])) seen++
    pos++
  }
  try {
    el.setSelectionRange(pos, pos)
  } catch {
    /* inputs type=email/number não suportam seleção — ignora */
  }
}

function onInput(event) {
  const el = event.target
  if (!el || el.nodeType !== 1) return

  const kind = el.getAttribute("data-mask")
  if (kind && FORMATTERS[kind]) {
    applyMask(el, FORMATTERS[kind])
  } else if (el.hasAttribute("data-lowercase")) {
    el.value = el.value.toLowerCase()
  }
}

document.addEventListener("input", onInput)

// Formata o que já veio preenchido do servidor (telas de edição).
export function formatPrefilled(root = document) {
  root.querySelectorAll("[data-mask]").forEach((el) => {
    const formatter = FORMATTERS[el.getAttribute("data-mask")]
    if (formatter && el.value) el.value = formatter(el.value)
  })
}

window.addEventListener("DOMContentLoaded", () => formatPrefilled())
